import styled, { keyframes } from "styled-components";
import theme from "../theme";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Bone = styled.div`
  background: linear-gradient(
    90deg,
    ${theme.cardBorder} 25%,
    ${theme.bgAlt}      50%,
    ${theme.cardBorder} 75%
  );
  background-size: 600px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: ${(p) => p.$r || "6px"};
  width: ${(p) => p.$w || "100%"};
  height: ${(p) => p.$h || "12px"};
  flex-shrink: 0;
`;

const Card = styled.div`
  background: ${theme.cardBg};
  border: 1.5px solid ${theme.cardBorder};
  border-radius: 12px;
  padding: 18px 16px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ActionRow = styled.div`display: flex; gap: 6px; margin-top: 4px;`;

export default function FolderCardSkeleton() {
  return (
    <Card>
      <Bone $w="28px" $h="28px" $r="7px" />
      <Bone $w="65%" $h="13px" />
      <Bone $w="40%" $h="11px" />
      <ActionRow>
        <Bone $w="52px" $h="22px" $r="5px" />
        <Bone $w="44px" $h="22px" $r="5px" />
        <Bone $w="48px" $h="22px" $r="5px" />
      </ActionRow>
    </Card>
  );
}
